import {
  FinancialModelSettings,
  OWCModelSettingsType,
} from "@/feature/financial-model/api/types"

export const getOwcModuleCompletitionStatus = (
  type: OWCModelSettingsType,
  settings: FinancialModelSettings[]
) => {
  const status =
    settings?.find((setting) => setting?.type === type)?.status ?? `not_started`
  return status
}
